<div class="flex items-center gap-2">
  <div
    class="rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden relative"
    [ngClass]="{
      'w-9 h-9': logoSize() === 'base',
      'w-6 h-6': logoSize() === 'sm'
    }"
  >
    <img 
      [src]="safeLogoUrl()"
      [alt]="name()"
      (error)="handleImageError()"
      class="absolute inset-0 w-full h-full object-contain transition-opacity duration-150 !text-xs"
      [style.opacity]="hasLogoError ? 0 : 1"
    />

    @if(hasLogoError) {
      <div
        class="rounded-full bg-gray-300 flex items-center justify-center flex-shrink-0"[ngClass]="{
          'w-9 h-9': logoSize() === 'base',
          'w-6 h-6': logoSize() === 'sm'
        }"
      >
        <i class="pi pi-question text-gray-600 text-xs"></i>
      </div>
    }
  </div>

  <span>{{ name() }}</span>
</div>
